import AddEducationModal from "./AddEducationModal";

export default AddEducationModal;
